import './EditMember.css'; // Adjust the import path based on your project structure
import '../Popup.css'; // Import your CSS file for styling

import React, {
  useEffect,
  useRef,
  useState,
} from 'react';

import axios from 'axios';
import { useLocation } from 'react-router-dom';
import Select from 'react-select'; // Import the Select component
import { get } from '../../service/apiService';

import {
  API_BASE_URL,
  API_KEY,
} from '../../constants';
import Nav from '../SecureNav/Nav.js';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import axiosInstance from '../../axios.js';
const EditMember = (props) => {
  const router_url = `members-all-info/`;
  //const userData = JSON.parse(localStorage.getItem('userData')) || {}
  const member_id=window.location.href.split("/")[3]
  const dobRef=useRef(null)
  const location = useLocation();
  const [assMemName, setassMemName] = useState(null);
  const [responseData,setresponseData]= useState(null);
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    relationship: 'Father',
    gender: 'Male',
    profile_pic: null,
    mobile: null,
    country_code: '+91',
    email: null,
    is_living: true,
    associated_member: null,
    author: null,
    native:null,
    lineage:null,
    pincode:null,
    street:null,
    profile_pic_uploaded:false
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
   // console.log(formData);
    responseData.data.member_details.first_name=formData.first_name;
    responseData.data.member_details.last_name=formData.last_name;
    responseData.data.member_details.nickname=formData.nickname;
    responseData.data.member_details.gender=formData.gender=='Female'?'F':'M';
    responseData.data.member_details.gender=formData.gender=='Other'?'O':responseData.data.member_details.gender;
    responseData.data.member_details.is_living=formData.is_living;
    responseData.data.member_details.dob=formData.dob;
    responseData.data.member_details.dod=formData.dod;
    responseData.data.member_dream={}
    responseData.data.member_professions={}
    responseData.data.member_address.street=formData.street;
    responseData.data.member_address.lineage=formData.lineage
    responseData.data.member_address.native=formData.native
    responseData.data.member_address.city=city_name.value
    responseData.data.member_address.state=state_name.value
    responseData.data.member_address.country=country_name.value
    responseData.data.member.mobile=formData.mobile?formData.mobile:"";
    responseData.data.member.email=formData.email;
    responseData.data.member_address.postal_code=formData.pincode
    responseData.data.member_address.member=member_id
    responseData.data.member_address.house_number=null  
    responseData.data.member_address.updated_at =new Date().toISOString()
    responseData.data.member_address.create_at =new Date().toISOString()
    delete responseData.data.member_details.profile_pic
    delete responseData.data.member_details.cover_pic

    console.log("sending...",responseData.data);
    try {
      const response = await axiosInstance.put(`${API_BASE_URL}members-all-info/`+member_id,
      responseData.data,
        {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
        }
      );

      const baseUrl = window.location.origin;
      const url = `${baseUrl}/webtree/`+member_id;
      alert("Member Details Updated Successfully!")
      window.location.href=url
    } catch (error) {
      let error_alert=[]
      console.error('Error while saving data:', error);
      const error_list=error.response.data.errors.errors
      error_list.forEach(function (item, index) {
        if(item.non_field_errors)
        {
          error_alert=error_alert.concat(item.non_field_errors)

        }
        else if(error_list[0].email)
        {
          error_alert=error_alert.concat(error_list[0].email)

        }
        else if(error_list[0].mobile)
        {
          error_alert=error_alert.concat(error_list[0].mobile)

        }
        else{
          error_alert=error_alert.concat(item)
        }
      });
      alert(error_alert.toString("\n"))
    }

    if(formData.profile_pic_uploaded)
    {
      try {
        let formDataNew = new FormData();
        formDataNew.append("profile_pic", formData.profile_pic);

        const response = await axios.post(
          `${API_BASE_URL}/api/v1/profile-pic/`+member_id,formDataNew,
          {
            headers: {
              'X-Api-Key': API_KEY,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        // Handle response as needed

      } catch (error) {
        console.error('Uploading profile pic:', error);
      }
    }

  };

  // Set the default country code to +91
  const defaultCountryCode = '+91';

  const [country_codes, setUser] = useState({
    country_code: { value: defaultCountryCode, label: defaultCountryCode },
    mobile: null,

  });

  const [loading, setLoading] = useState(true);
  const [countries, setCountries] = useState({});
  const [states, setStates] = useState({});
  const [cities, setCities] = useState({});
  const [CountryNames,setCountryNames]=useState({})
  const [state_name,setStateName]= useState("");
  const [city_name,setCityName] = useState("");
  const [country_name,setCountryName]=useState("");
  const [dream,setDream]=useState({})
  const [tabValue, setTabValue] = useState('1');
  const [emailEditStatus,setEmailEditStatus]=useState(false)
  const [mobileEditStatus,setMobileEditStatus]=useState(false)
  const [selectedSpouses, setSelectedSpouses] = useState([]);
  const [spouseList, setSpousesList] = useState([]);
  const dodRef=useRef(null)
  const [dodVisibility,setdodVisibility]= useState(true);

  const handleDod=(e)=>{
    document.getElementById("dod").type='date';
  }
  // const spouseList = [{"name":"kumar","member_id":"1"}, {"name":"shubham","member_id":"2"}, {"name":"this","member_id":"3"}];

  
  // const handleDreamSubmit = async (e) => {
  //   handleHideSpouse
  //   e.preventDefault();
  //   const dream_obj={
  //     "dream": dream,
  //     "create_at": new Date().toISOString(),
  //     "updated_at": new Date().toISOString(),
  //     "member":member_id
  //   }
  //   try {
  //     if(dreamId){
  //         const response = await axiosInstance.put(`${API_BASE_URL}member-dreams/`+dreamId+"/",
  //         dream_obj,
  //           {
  //             headers: {
  //               'X-Api-Key': API_KEY,
  //               'Content-Type': 'application/json',
  //               'Accept': 'application/json',
  //             },
  //           }
  //         );
  //     }
  //     else{
  //       const response = await axiosInstance.post(`${API_BASE_URL}member-dreams/`,
  //         dream_obj,
  //           {
  //             headers: {
  //               'X-Api-Key': API_KEY,
  //               'Content-Type': 'application/json',
  //               'Accept': 'application/json',
  //             },
  //           }
  //         );
  //     }

  //     const baseUrl = window.location.origin;
  //     const url = `${baseUrl}/webtree/`+member_id;
  //    window.location.href=url
  //   } catch (error) {
  //     console.error('Error while saving data:', error);
  //   }

  // };
  const handleHideSpouse = async (e) => {
    e.preventDefault();
    const formData={
      "spouses": selectedSpouses,
      "member":member_id
    }
    try {
          const response = await axiosInstance.post(`${API_BASE_URL}hide-spouse`,
            formData,
            {
              headers: {
                'X-Api-Key': API_KEY,
                'Content-Type': 'application/json',
                'Accept': 'application/json',
              },
            }
          );
          if(response.status==200){
            if(response.data && response.data.data.message){
              alert(response.data.data.message)
            }
          }
          const baseUrl = window.location.origin;
          const url = `${baseUrl}/webtree/`+member_id;
          window.location.href=url
          // console.log(response)
    
    } catch (error) {
      console.error('Error while saving data:', error);
    }

  };
  const handleCheckboxChange = (spouse) => (event) => {
    if (event.target.checked) {
      setSelectedSpouses([...selectedSpouses, spouse]);
    } else {
      setSelectedSpouses(selectedSpouses.filter((item) => item !== spouse));
    }
  };
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const [imagePreview, setImagePreview] = useState(null);
  const fileInputRef = useRef(null);
  const [dreamId,setDreamId]= useState({});

  const handleCountryCodeChange = (selectedOption) => {
    setUser((prevUser) => ({
      ...prevUser,
      country_code: selectedOption,
    }));
  };

  const handleDreamChange = (event) => {
    setDream(event.target.value);
  };


  const handleCountryNameChange = (selectedOption) => {
    setCountryName(selectedOption);
  };
  const handleStateChange = (selectedOption) => {
    setStateName(selectedOption);
  };
  
  const handleCityChange = (selectedOption) => {
    setCityName(selectedOption);
  };
  const handleUpload = (e) => {
    const file = e.target.files[0];
    formData.profile_pic=file;
    formData.profile_pic_uploaded=true
    if (file) {
      const reader = new FileReader();

      reader.onloadend = () => {
        setImagePreview(reader.result);
      };

      reader.readAsDataURL(file);
      let img =file
      try {
        let newFormData = new FormData();
        newFormData.append("profile_pic", img);

        const response = axiosInstance.post(
          `${API_BASE_URL}profile-pic/`+member_id,newFormData,
          {
            headers: {
              'X-Api-Key': API_KEY,
              "Content-Type": "multipart/form-data",
            },
          }
        ).then((response)=>alert("successfully Uploaded!"));
        // Handle response as needed

      } catch (error) {
        console.error('Uploading profile pic:', error);
      }
    }
  };
  const handleDob=(e)=>{
    document.getElementById("dob").type='date';
  }

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    if (type === 'file') {
      setFormData((prevData) => ({
        ...prevData,
        [name]: files[0],
      }));

      const reader = new FileReader();
      reader.onload = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(files[0]);
    } else {
        if(name=='is_living'){
          if(!checked){
            setdodVisibility(false);
          }
          else{
            setdodVisibility(true);
          }
      }
      setFormData((prevData) => ({
        ...prevData,
        [name]: type === 'checkbox' ? checked : value,
      }));
     // console.log(formData)
    }

    if (name === 'relationship') {
      // If relationship changes, update gender based on the selected relationship
      setFormData((prevData) => ({
        ...prevData,
        gender: getGenderForRelation(value),
      }));
    }
  };

  const getGenderForRelation = (relationship) => {


    if (relationship === 'Wife' || relationship === 'Mother' || relationship === 'Daughter') {
      formData.gender = 'Female'
      return 'Female';
    } else {
      formData.gender = 'Male'
      return 'Male';
    }
  };

  useEffect(() => {
    const fetchDataAndSetFields = async () => {
  
        try {
          const response = await axiosInstance.get(`${API_BASE_URL}${router_url}${member_id}`);
          console.log(responseData)
          if(response && response.data){
            const responseData=response.data

           // console.log(responseData.data);
            const member_details=responseData.data.member_details;
            const member_address=responseData.data.member_address;
            const member_dream=responseData.data.member_dream;
            let gender=responseData.data.member_details.gender=="M"?"Male":"Female";
            gender=responseData.data.member_details.gender=="O"?"Other":gender;
            const profile_pic=member_details.profile_pic?member_details.profile_pic:''
            setFormData({dod:member_details.dod,dob:member_details.dob,first_name:member_details.first_name,last_name:member_details.last_name,gender:gender,profile_pic:member_details.profile_pic,mobile:responseData.data.member.mobile,email:responseData.data.member.email,is_living:member_details.is_living,pincode:member_address.postal_code,lineage:member_address.lineage,native:member_address.native,nickname:member_details.nickname,street:member_address.street})
            if(!member_details.is_living)
            {
              setdodVisibility(false);
            }
            if(member_address.city){
              setCityName({value:member_address.city,label:member_address.city})
            }
            if(member_address.state) 
            {
              setStateName({value:member_address.state,label:member_address.state})
            }
            if(member_address.country){
              setCountryName({value:member_address.country,label:member_address.country})
            }
            setImagePreview(profile_pic);
            setresponseData(responseData);
            setDream(member_dream.dream);
            setDreamId(member_dream.id)
        }
        } catch (error) {
          console.error("An error occurred while fetching data:", error);
        }
      };
  
      fetchDataAndSetFields();

  }, []);

  const fetchSpouses = async () => {
    try {
      const response = await axiosInstance.get(`${API_BASE_URL}spouses?member_id=${member_id}`, {
        headers: {
          'X-Api-Key': API_KEY,
        },
      });
      console.log('API Response:', response);
  
      if (response.data && response.data.data) {
        const spouseOptions = response.data.data.map((spouse) => ({
          member_id: spouse.member_id,
          name: spouse.name,
        }));
        setSpousesList(spouseOptions);
        console.log('Spouse List:', spouseOptions);
      } else {
        console.warn('No data found in response:', response);
      }
    } catch (error) {
      console.error('Error fetching spouses:', error);
    }
  };
  

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axiosInstance.get(`${API_BASE_URL}countries/`);
        const countryOptions = response.data.data.map((country) => ({
          value: country.dial_code,
          label: country.dial_code,
        }));
        setCountries(countryOptions);
        const countryNameOptions = response.data.data.map((country) => ({
          value: country.name,
          label: country.name,
        }));
        setCountryNames(countryNameOptions);
      } catch (error) {
        console.error('Error fetching country codes:', error);
      } finally {
        setLoading(false);
      }
    };
    const fetchStates = async () => {
      try {
        const response = await axiosInstance.get(`${API_BASE_URL}states/`);
        const stateOptions = response.data.data.map((state) => ({
          value: state.name,
          label: state.name,
        }));
       // stateOptions.unshift({value:"",label:"State"})
        setStates(stateOptions);
      } catch (error) {
        console.error('Error fetching country codes:', error);
      } finally {
        setLoading(false);
      }
    };

    const fetchCities = async () => {
      try {
        const response = await axiosInstance.get(`${API_BASE_URL}cities/`);
        const cityOptions = response.data.results.map((city) => ({
          value: city.name,
          label: city.name,
        }));
        setCities(cityOptions);
      } catch (error) {
        console.error('Error fetching country codes:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchSpouses()
    fetchCountries();
    fetchStates();
    fetchCities();
  }, []);
 
  return (
    <>
      <Nav />
      <TabContext value={tabValue}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <TabList onChange={handleTabChange} aria-label="Member Details" centered>
          <Tab label="Personal Details" value="1" />
          <Tab label="Hide Spouses" value="2" />
        </TabList>
      </Box>
      <TabPanel value="1"><form onSubmit={handleSubmit}>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <div className="card" style={{ width: '100%' }}>
            <div className="card-body">
              <div className="row">
                <div className="column" style={{}}>
                  <div className="circle-container">
                    <div className="circle" onClick={()=>fileInputRef.current.click()}>
                      {imagePreview? <img src={imagePreview} alt="" className="preview-image" />:''}
                        <>
                          <input
                            type="file"
                            id="uploadInput"
                            className="upload-input"
                            onChange={handleUpload}
                            ref={fileInputRef}
                          />
                          <label htmlFor="uploadInput" className="upload-button">
                            Upload
                          </label>
                        </>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      Your privacy is very important to us. No one outside your family can see your family information.
                    </div>
                  </div>
                </div>
                <div className="column" style={{}}>
                  <div className="row" style={{ paddingTop: '10px' }}>
                    <div className="col">
                      <div className="form-check">
                        <input
                          type="radio"
                          className="form-check-input radio-button"
                          name="gender"
                          value="Male"
                          checked={formData.gender === 'Male'}
                          onChange={handleChange}
                        />
                        <label className="form-check-label">Male</label>
                      </div>
                    </div>
                    <div className="col">
                      <div className="form-check">
                        <input
                          type="radio"
                          className="form-check-input radio-button"
                          name="gender"
                          value="Female"
                          checked={formData.gender === 'Female'}
                          onChange={handleChange}
                        />
                        <label className="form-check-label">Female</label>
                      </div>
                    </div>
                    <div className="col">
                      <div className="form-check">
                        <input
                          type="radio"
                          className="form-check-input  radio-button"
                          name="gender"
                          value="Other"
                          checked={formData.gender === 'Other'}
                          onChange={handleChange}
                        />
                        <label className="form-check-label">Other</label>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <input
                        type="text"
                        name="first_name"
                        placeholder="First Name"
                        value={formData.first_name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col">
                      <input
                        type="text"
                        name="last_name"
                        placeholder="Last Name"
                        value={formData.last_name}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-4">
                      <Select
                        id="country_code"
                        value={country_codes.country_code}
                        onChange={handleCountryCodeChange}
                        options={countries}
                        placeholder="Country Code"
                      />
                    </div>
                    <div className="col-8">
                      <input
                        type="tel"
                        name="mobile"
                        placeholder="Mobile Number"
                        value={formData.mobile}
                        onChange={handleChange}
                        disabled={mobileEditStatus}

                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <input
                        type="text"
                        name="nickname"
                        placeholder="Popularly known as"
                        value={formData.nickname}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-6">
                      <input
                        type="text"
                        ref={dobRef}
                        name="dob"
                        id="dob"
                        placeholder="Date of Birth"
                        value={formData.dob}
                        onChange={handleChange}
                        onFocus={handleDob}

                      />
                      </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <input
                        type="text"
                        name="email"
                        placeholder="Email"
                        value={formData.email}
                        onChange={handleChange}
                        disabled={emailEditStatus}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <input
                        type="text"
                        name="street"
                        placeholder="Address"
                        value={formData.street}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <input
                        id="native"
                        type="text"
                        name="native"
                        placeholder="Native"
                        value={formData.native}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col">
                      <input
                      id="lineage"
                        type="text"
                        name="lineage"
                        placeholder="Lineage"
                        value={formData.lineage}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="row">
                  <div className="col">
                        <Select
                          id="city_name"
                          name="city_name"
                          value={city_name}
                          onChange={handleCityChange}
                          options={cities}
                          placeholder="City"
                        />
                      </div>
                    <div className="col">
                      <input
                        type="text"
                        id="pincode"
                        name="pincode"
                        placeholder="Pincode"
                        value={formData.pincode}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                        <Select
                          id="state_name"
                          name="state_name"
                          value={state_name}
                          onChange={handleStateChange}
                          options={states}
                          placeholder="State"
                        />
                      </div>
                      <div className="col">
                      <Select
                          id="country_name"
                          name="country_name"
                          value={country_name}
                          onChange={handleCountryNameChange}
                          options={CountryNames}
                          placeholder="Country"
                        />
                      </div>
                  </div>
                  &nbsp; &nbsp;
                  <div className="row">
                    <div className="col-6" style={{ display: 'flex', alignItems: 'center' }}>
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          name="is_living"
                          checked={formData.is_living}
                          onChange={handleChange}
                        />
                        <label className="form-check-label"> &nbsp; &nbsp;Living</label>
                      </div>
                    </div>
                    <div className="col-6" hidden={dodVisibility}>
                      <input
                        type="text"
                        ref={dodRef}
                        id="dod"
                        name="dod"
                        placeholder="Date of Death"
                        value={formData.dod}
                        onChange={handleChange}
                        onFocus={handleDod}
                      />
                    </div>


                  </div>
                </div>
              </div>
            </div>
            <div>
              <button type="submit">Save Changes</button>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <button type="button" onClick={() =>window.location.href=`${window.location.origin}/webtree/`+member_id}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </form></TabPanel>
      <TabPanel value="2">
        <div >
        <p style={{ fontWeight: 'bold', marginBottom: '10px' }}>
          Please select the checkbox for the spouses you want to hide.
        </p>
          <div className="card" style={{ width: '100%', marginBottom: '20px' }}>
            <div className="card-body">
              {spouseList.map((spouse) => (
                <div key={spouse.member_id} style={{ marginBottom: '5px' }}>
                  <label >
                    <input
                      type="checkbox"
                      checked={selectedSpouses.includes(spouse.member_id)}
                      onChange={handleCheckboxChange(spouse.member_id)}
                      style={{ marginRight: '5px' }}
                    />
                    {spouse.name}
                  </label>
                </div>
              ))}
            </div>
          </div>
          <button id="hideSpouse" onClick={handleHideSpouse}>
           Submit
          </button>
        </div>
      </TabPanel>
      </TabContext>
      
    </>
  );
};

export default EditMember;
